var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.renderComp)?_c('cart-item',{attrs:{"cart":_vm.getactivecart,"active":_vm.getactivecart},on:{"cleancart":function($event){return _vm.$emit('cleancart', $event)},"deletesuborder":function($event){return _vm.$emit('deletesuborder', $event)}}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25256008","hasScoped":false,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Catalog/Carts.vue
// module id = 1784
// module chunks = 0